import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import Rentify from '../Projects Images/Rentify.png'
import Becool from '../Projects Images/Becool.png'
import Outlook from "../Projects Images/Outlook India Image.png";
import KindMeal from "../Projects Images/KindMeal.png";
import TrackingTime from "../Projects Images/TrackingTime.png";
import HackAppAxis from '../Projects Images/HackAppAxis.png'
import { makeStyles } from "@material-ui/core/styles";
import GitHubIcon from "@mui/icons-material/GitHub";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Link from "@mui/material/Link";
import React from "react";
import GitHubCalendar from "react-github-calendar";

function Projects() {
  const useStyles = makeStyles({
    outlookHover: {
      "&:hover": {
        scale: "1.04",
        transition: "scale 0.7s",
      },
    },
    github: {
      "&:hover": {
        scale: "1.5",
        transition: "0.8s",
        color: "white",
      },
    },
  });

  const classes = useStyles();

  const colorTheme = {
    background: 'transparent',
    text: '#ffffff',
    level4: '#003300',
    level3: '#005500',
    level2: '#009900',
    level1: '#00ff00',
    level0: 'white',
  }

  const selectLastHalfYear = (contributions) => {
    const currentYear = new Date().getYear();
    const currentMonth = new Date().getMonth();
    const shownMonths = 1;

    return contributions.filter((day) => {
      const date = new Date(day.date);
      const monthOfDay = date.getMonth();

      return (
        date.getFullYear() === currentYear &&
        monthOfDay > currentMonth - shownMonths &&
        monthOfDay <= currentMonth
      );
    });
  };

  return (
    <Box
      sx={{
        color: "white",
        backgroundColor:'black',
        margin: "auto",
        width: "100vw",
        height: "100%",
        paddingTop: { lg: "75px", md: "75px", sm: "70px", xs: "70px" }
      }}
    >
      <Box
        sx={{
          width: '90vw',
          margin: "auto",
          textAlign: "justify",
          fontSize: "55px",
          color: "teal",
          boxSizing: "border-box",
          padding: "0px",
        }}
      >
        Projects
        <hr />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: { lg: "80vw", md: "85vw", sm: "85vw", xs: "85vw" },
          margin: "50px auto 0px",
          gap: "50px",
          paddingBottom: "50px",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { lg: "5fr 30fr 1fr", md: "1fr" },
            alignItems: "center",
            boxShadow: "1px 1px 5px rgb(255 255 51)",
            boxSizing: "border box",
            padding: "20px",
            marginBottom:{sm:'25px',xs:'25px'}
          }}
        >
          <Box sx={{ width: { lg: "400px", md: "100%",sm:'100%',xs:'100%'} }}>
            <Link href="https://rentify-khadsepranay.vercel.app/" target='_blank'>
              <Box
                component="img"
                src={Rentify}
                className={classes.outlookHover}
                width="100%"
              />
            </Link>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "40px", md: "40px", sm: "40px", xs: "33px" },
                textAlign: "center",
                letterSpacing: "1.5px",
                color: "yellow",
                marginTop: { lg: "-20px", md: "20px", sm: "20px", xs: "20px" },
                width:'100%'
              }}
            >
              Rentomojo - Clone
            </Typography>
            <Box
              sx={{
                fontSize: { lg: "17px", md: "17px", sm: "17px", xs: "14px" },
                textAlign: "center",
                lineHeight: { lg: "35px", md: "35px", sm: "35px", xs: "25px" },
                padding:{lg:'0px 20px',md:'0px 20px',sm:'0px 20px',xs:'0px 10px'},
                boxSizing: "border-box",
                width:'100%'
              }}
            >
              Rentify is the clone of Rentomojo rental website where you can find furnitures and other needed things on rent. It is a collaborative project with 5 team members created in 4 days.
            </Box>
            <Box
              sx={{
                display: {lg:'flex',md:'grid',sm:"grid",xs:'grid'},
                gridTemplateColumns:'1fr 1fr',
                justifyContent: "space-around",
                margin: {lg:'30px 10px 0px',md:'30px 80px 0px',sm:'30px 80px 0px',xs:'30px 0px 0px'},
                gap:{xs:'10px 20px'},
              }}
            >
              <Typography
                sx={{
                  border: "1px solid teal",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "teal",
                }}
              >
                ReactJS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid yellow",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 23px",
                  },
                  borderRadius: "10px",
                  color: "yellow",
                }}
              >
                ExpressJS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid #00994C",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 12px",
                  },
                  borderRadius: "10px",
                  color: "#00994C",
                }}
              >
                MongoDB
              </Typography><Typography
                sx={{
                  border: "1px solid teal",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "teal",
                }}
              >
                Material UI
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { lg: "column", md: "row", sm: "row", xs: "row" },
              justifyContent: {
                lg: "space-around",
                md: "center",
                sm: "center",
                xs: "center",
              },
              gap: { lg: "40px", md: "80px", sm: "70px", xs: "50px" },
              marginTop: { lg: "0px", md: "35px", sm: "35px", xs: "35px" },
            }}
          >
            <Link
              href="https://github.com/khadsepranay/Rentify.com"
              className={classes.github} target='_blank'
            >
              <GitHubIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
            <Link
              href="https://rentify-khadsepranay.vercel.app/"
              className={classes.github}  target='_blank'
            >
              <RemoveRedEyeIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px'}} />
            </Link>
          </Box>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { lg: "5fr 30fr 1fr", md: "1fr" },
            alignItems: "center",
            boxShadow: "1px 1px 5px rgb(250 77 141)",
            boxSizing: "border box",
            padding: "20px",
            marginBottom:{sm:'25px',xs:'25px'}
          }}
        >
          <Box sx={{ width: { lg: "400px", md: "100%" } }}>
            <Link href="https://trackingtime-khadsepranay.vercel.app/login"  target='_blank'>
              <Box
                component="img"
                src={TrackingTime}
                width="100%"
                className={classes.outlookHover}
              />
            </Link>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "40px", md: "40px", sm: "40px", xs: "33px" },
                textAlign: "center",
                letterSpacing: "1.5px",
                color: "rgb(255 6 97)",
                marginTop: { lg: "-20px", md: "20px", sm: "20px", xs: "20px" },
              }}
            >
              Tracking Time - Clone
            </Typography>
            <Box
              sx={{
                fontSize: { lg: "17px", md: "17px", sm: "17px", xs: "14px" },
                textAlign: "center",
                lineHeight: { lg: "35px", md: "35px", sm: "35px", xs: "25px" },
                padding:{lg:'0px 20px',md:'0px 20px',sm:'0px 20px',xs:'0px 10px'},
                boxSizing: "border-box",
              }}
            >
              Exact clone of Time Tracking website knows as Tracking Time with
              single page application includes login Functionality via reqres.
            </Box>
            <Box
              sx={{
                display: {lg:'flex',md:'grid',sm:"grid",xs:'grid'},
                gridTemplateColumns:'1fr 1fr',
                justifyContent: "space-around",
                margin: {lg:'30px 10px 0px',md:'30px 80px 0px',sm:'30px 80px 0px',xs:'30px 0px 0px'},
                gap:{xs:'10px 30px'},
              }}
            >
              <Typography
                sx={{
                  border: "1px solid teal",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "teal",
                }}
              >
                ReactJS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid rgba(102 178 255)",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 23px",
                  },
                  borderRadius: "10px",
                  color: "rgba(102 178 255)",
                }}
              >
                CSS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid yellow",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 12px",
                  },
                  borderRadius: "10px",
                  color: "yellow",
                }}
              >
                JavaScript
              </Typography>
              <Typography
                sx={{
                  border: "1px solid teal",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "teal",
                }}
              >
                Chakra UI
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { lg: "column", md: "row", sm: "row", xs: "row" },
              justifyContent: {
                lg: "space-around",
                md: "center",
                sm: "center",
                xs: "center",
              },
              gap: { lg: "40px", md: "80px", sm: "70px", xs: "50px" },
              marginTop: { lg: "0px", md: "35px", sm: "35px", xs: "35px" },
            }}
          >
            <Link
              href="https://github.com/khadsepranay/crowded-push-1335/tree/main/trackingtime"
              className={classes.github}  target='_blank'
            >
              <GitHubIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
            <Link
              href="https://trackingtime-khadsepranay.vercel.app/login"
              className={classes.github} target='_blank'
            >
              <RemoveRedEyeIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
          </Box>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { lg: "5fr 30fr 1fr", md: "1fr" },
            alignItems: "center",
            boxShadow: "1px 1px 5px #66b2ff",
            boxSizing: "border box",
            padding: "20px",
            marginBottom:{sm:'25px',xs:'25px'}
          }}
        >
          <Box sx={{ width: { lg: "400px", md: "100%" } }}>
            <Link href="https://hack-app-axis.vercel.app/"  target='_blank'>
              <Box
                component="img"
                src={HackAppAxis}
                className={classes.outlookHover}
                width="100%"
              />
            </Link>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "40px", md: "40px", sm: "40px", xs: "33px" },
                textAlign: "center",
                letterSpacing: "1.5px",
                color: "#66b2ff",
                marginTop: { lg: "-20px", md: "20px", sm: "20px", xs: "20px" },
              }}
            >
              Interview Point
            </Typography>
            <Box
              sx={{
                fontSize: { lg: "17px", md: "17px", sm: "17px", xs: "14px" },
                textAlign: "center",
                lineHeight: { lg: "35px", md: "35px", sm: "35px", xs: "25px" },
                padding:{lg:'0px 20px',md:'0px 20px',sm:'0px 20px',xs:'0px 10px'},
                boxSizing: "border-box",
              }}
            >
              Interview Point is a website where we can learn and explore things around MERN and DSA. And practice for there interview. To start explore our website just have to register and login. This is a collaborative project of three members which is completed in 2 days
            </Box>
            <Box
              sx={{
                display: {lg:'flex',md:'flex',sm:"flex",xs:'grid'},
                gridTemplateColumns:{xs:'1fr 1fr'},
                justifyContent: "space-around",
                gap:{xs:'15px'},
                justifyContent: "space-around",
                marginTop: { lg: "30px", md: "30px", sm: "30px", xs: "30px" },
              }}
            >
              <Typography
                sx={{
                  border: "1px solid teal",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "teal",
                }}
              >
                ReactJS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid #004c99",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "#004c99",
                }}
              >
                TypeScript
              </Typography>
              <Typography
                sx={{
                  border: "1px solid yellow",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "yellow",
                }}
              >
                ExpressJS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid #66b2ff",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "#66b2ff",
                }}
              >
                NextJS
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { lg: "column", md: "row", sm: "row", xs: "row" },
              justifyContent: {
                lg: "space-around",
                md: "center",
                sm: "center",
                xs: "center",
              },
              gap: { lg: "40px", md: "80px", sm: "70px", xs: "50px" },
              marginTop: { lg: "0px", md: "35px", sm: "35px", xs: "35px" },
            }}
          >
            <Link
              href="https://github.com/AMARDEEP115/HackAppAxis"
              className={classes.github} target='_blank'
            >
              <GitHubIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
            <Link
              href="https://hack-app-axis.vercel.app/"
              className={classes.github} target='_blank'
            >
              <RemoveRedEyeIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px'}} />
            </Link>
          </Box>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { lg: "5fr 30fr 1fr", md: "1fr" },
            alignItems: "center",
            boxShadow: "1px 1px 5px #00CCCC",
            boxSizing: "border box",
            padding: "20px",
            marginBottom:{sm:'25px',xs:'25px'}
          }}
        >
          <Box sx={{ width: { lg: "400px", md: "100%",sm:'100%',xs:'100%'} }}>
            <Link href="https://frontend-khadsepranay.vercel.app/" target='_blank'>
              <Box
                component="img"
                src={Becool}
                className={classes.outlookHover}
                width="100%"
              />
            </Link>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "40px", md: "40px", sm: "40px", xs: "33px" },
                textAlign: "center",
                letterSpacing: "1.5px",
                color: "#00CCCC",
                marginTop: { lg: "-20px", md: "20px", sm: "20px", xs: "20px" },
                width:'100%'
              }}
            >
              Bewkoof - Clone
            </Typography>
            <Box
              sx={{
                fontSize: { lg: "17px", md: "17px", sm: "17px", xs: "14px" },
                textAlign: "center",
                lineHeight: { lg: "35px", md: "35px", sm: "35px", xs: "25px" },
                padding:{lg:'0px 20px',md:'0px 20px',sm:'0px 20px',xs:'0px 10px'},
                boxSizing: "border-box",
                width:'100%'
              }}
            >
              Becool is a clone of Bewkoof.com which provides lifestyle fashion brand that makes creative, distinctive fashion for the trendy, contemporary Indian.
            </Box>
            <Box
              sx={{
                display: {lg:'flex',md:'grid',sm:"grid",xs:'grid'},
                gridTemplateColumns:'1fr 1fr',
                justifyContent: "space-around",
                margin: {lg:'30px 10px 0px',md:'30px 80px 0px',sm:'30px 80px 0px',xs:'30px 0px 0px'},
                gap:{xs:'10px 20px'},
              }}
            >
              <Typography
                sx={{
                  border: "1px solid teal",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "teal",
                }}
              >
                ReactJS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid yellow",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 23px",
                  },
                  borderRadius: "10px",
                  color: "yellow",
                }}
              >
                ExpressJS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid #00994C",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 12px",
                  },
                  borderRadius: "10px",
                  color: "#00994C",
                }}
              >
                MongoDB
              </Typography><Typography
                sx={{
                  border: "1px solid teal",
                  fontSize: { lg: "16px", md: "18px", sm: "14px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 32px",
                    sm: "3px 15px",
                    xs: "3px 15px",
                  },
                  borderRadius: "10px",
                  color: "teal",
                }}
              >
                Material UI
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { lg: "column", md: "row", sm: "row", xs: "row" },
              justifyContent: {
                lg: "space-around",
                md: "center",
                sm: "center",
                xs: "center",
              },
              gap: { lg: "40px", md: "80px", sm: "70px", xs: "50px" },
              marginTop: { lg: "0px", md: "35px", sm: "35px", xs: "35px" },
            }}
          >
            <Link
              href="https://github.com/khadsepranay/Becool.com"
              className={classes.github} target='_blank'
            >
              <GitHubIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
            <Link
              href="https://frontend-khadsepranay.vercel.app/"
              className={classes.github}  target='_blank'
            >
              <RemoveRedEyeIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px'}} />
            </Link>
          </Box>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { lg: "5fr 30fr 1fr", md: "1fr" },
            alignItems: "center",
            boxShadow: "1px 1px 5px orange",
            boxSizing: "border box",
            padding: "20px",
            marginBottom:{sm:'25px',xs:'25px'}
          }}
        >
          <Box sx={{ width: { lg: "400px", md: "100%" } }}>
            <Link href="https://snazzy-pasca-842614.netlify.app/"  target='_blank'>
              <Box
                component="img"
                src={Outlook}
                className={classes.outlookHover}
                width="100%"
              />
            </Link>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "40px", md: "40px", sm: "40px", xs: "33px" },
                textAlign: "center",
                letterSpacing: "1.5px",
                color: "orange",
                marginTop: { lg: "-20px", md: "20px", sm: "20px", xs: "20px" },
              }}
            >
              Outlook India - Clone
            </Typography>
            <Box
              sx={{
                fontSize: { lg: "17px", md: "17px", sm: "17px", xs: "14px" },
                textAlign: "center",
                lineHeight: { lg: "35px", md: "35px", sm: "35px", xs: "25px" },
                padding:{lg:'0px 20px',md:'0px 20px',sm:'0px 20px',xs:'0px 10px'},
                boxSizing: "border-box",
              }}
            >
              Exact clone of a daily news website known as Outlook India with 9
              pages including Signup and Login Functionality.
            </Box>
            <Box
              sx={{
                display: {lg:'flex',md:'flex',sm:"flex",xs:'grid'},
                gridTemplateColumns:{xs:'1fr 1fr'},
                justifyContent: "space-around",
                gap:{xs:'15px'},
                justifyContent: "space-around",
                marginTop: { lg: "30px", md: "30px", sm: "30px", xs: "30px" },
              }}
            >
              <Typography
                sx={{
                  border: "1px solid rgb(204 102 0)",
                  fontSize: { lg: "16px", md: "18px", sm: "16px", xs: "12px" },
                  padding: {
                    lg: "3px 32px",
                    md: "3px 32px",
                    sm: "3px 32px",
                    xs: "3px 23px",
                  },
                  borderRadius: "10px",
                  color: "rgb(204 102 0)",
                }}
              >
                HTML
              </Typography>
              <Typography
                sx={{
                  border: "1px solid rgba(102 178 255)",
                  fontSize: { lg: "16px", md: "18px", sm: "16px", xs: "12px" },
                  padding: {
                    lg: "3px 37px",
                    md: "3px 37px",
                    sm: "3px 37px",
                    xs: "3px 28px",
                  },
                  borderRadius: "10px",
                  color: "rgba(102 178 255)",
                }}
              >
                CSS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid yellow",
                  fontSize: { lg: "16px", md: "18px", sm: "16px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 15px",
                    sm: "3px 15px",
                    xs: "3px 12px",
                  },
                  borderRadius: "10px",
                  color: "yellow",
                }}
              >
                JavaScript
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { lg: "column", md: "row", sm: "row", xs: "row" },
              justifyContent: {
                lg: "space-around",
                md: "center",
                sm: "center",
                xs: "center",
              },
              gap: { lg: "40px", md: "80px", sm: "70px", xs: "50px" },
              marginTop: { lg: "0px", md: "35px", sm: "35px", xs: "35px" },
            }}
          >
            <Link
              href="https://github.com/khadsepranay/next-hill-6732"
              className={classes.github} target='_blank'
            >
              <GitHubIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
            <Link
              href="https://snazzy-pasca-842614.netlify.app/"
              className={classes.github} target='_blank'
            >
              <RemoveRedEyeIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px'}} />
            </Link>
          </Box>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { lg: "5fr 30fr 1fr", md: "1fr" },
            alignItems: "center",
            boxShadow: "1px 1px 5px rgb(153 255 51)",
            boxSizing: "border box",
            padding: "20px",
            marginBottom:{sm:'25px',xs:'25px'}
          }}
        >
          <Box sx={{ width: { lg: "400px", md: "100%" } }}>
            <Link href="https://lucent-chebakia-efbb4f.netlify.app/index.html"  target='_blank'>
              <Box
                component="img"
                src={KindMeal}
                className={classes.outlookHover}
                width="100%"
              />
            </Link>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "40px", md: "40px", sm: "40px", xs: "33px" },
                textAlign: "center",
                letterSpacing: "1.5px",
                color: "rgb(0 255 0)",
                marginTop: { lg: "-20px", md: "20px", sm: "20px", xs: "20px" },
              }}
            >
              KindMeal.my - Clone
            </Typography>
            <Box
              sx={{
                fontSize: { lg: "17px", md: "17px", sm: "17px", xs: "14px" },
                textAlign: "center",
                lineHeight: { lg: "35px", md: "35px", sm: "35px", xs: "25px" },
                padding:{lg:'0px 20px',md:'0px 20px',sm:'0px 20px',xs:'0px 10px'},
                boxSizing: "border-box",
              }}
            >
              A completely built website know as KindMeal.my, done in a group of
              5 member's with many functionalities like Login, Signup,
              Search, etc.
            </Box>
            <Box
              sx={{
                display: {lg:'flex',md:'flex',sm:"flex",xs:'grid'},
                gridTemplateColumns:{xs:'1fr 1fr'},
                justifyContent: "space-around",
                gap:{xs:'15px'},
                marginTop: { lg: "30px", md: "30px", sm: "30px", xs: "30px" },
              }}
            >
              <Typography
                sx={{
                  border: "1px solid rgb(204 102 0)",
                  fontSize: { lg: "16px", md: "18px", sm: "16px", xs: "12px" },
                  padding: {
                    lg: "3px 32px",
                    md: "3px 32px",
                    sm: "3px 32px",
                    xs: "3px 23px",
                  },
                  borderRadius: "10px",
                  color: "rgb(204 102 0)",
                }}
              >
                HTML
              </Typography>
              <Typography
                sx={{
                  border: "1px solid rgba(102 178 255)",
                  fontSize: { lg: "16px", md: "18px", sm: "16px", xs: "12px" },
                  padding: {
                    lg: "3px 37px",
                    md: "3px 37px",
                    sm: "3px 37px",
                    xs: "3px 28px",
                  },
                  borderRadius: "10px",
                  color: "rgba(102 178 255)",
                }}
              >
                CSS
              </Typography>
              <Typography
                sx={{
                  border: "1px solid yellow",
                  fontSize: { lg: "16px", md: "18px", sm: "16px", xs: "12px" },
                  padding: {
                    lg: "3px 15px",
                    md: "3px 15px",
                    sm: "3px 15px",
                    xs: "3px 12px",
                  },
                  borderRadius: "10px",
                  color: "yellow",
                }}
              >
                JavaScript
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { lg: "column", md: "row", sm: "row", xs: "row" },
              justifyContent: {
                lg: "space-around",
                md: "center",
                sm: "center",
                xs: "center",
              },
              gap: { lg: "40px", md: "80px", sm: "70px", xs: "50px" },
              marginTop: { lg: "0px", md: "35px", sm: "35px", xs: "35px" },
            }}
          >
            <Link
              href="https://github.com/VIC-PAUL/racial-class-2069"
              className={classes.github} target='_blank'
            >
              <GitHubIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
            <Link
              href="https://lucent-chebakia-efbb4f.netlify.app/index.html"
              className={classes.github} target='_blank'
            >
              <RemoveRedEyeIcon sx={{ fontSize: { lg: "25px", md: "33px" }, padding:'0px 20px' }} />
            </Link>
          </Box>
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            width: '90vw',
            margin: "auto",
            textAlign: "justify",
            fontSize: {lg:"55px",md:"55px",sm:"50px",xs:"45px"},
            color: "teal",
            boxSizing: "border-box",
            marginTop: "100px",
            padding: "0px",
          }}
        >
          Github Statistics
          <hr />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection:{lg:"row",md:"column",sm:"column",xs:"column"},
            justifyContent: "center",
            gap: "50px",
            margin: "50px 0",
          }}
        >
          <Box>
            <Link href="https://github.com/khadsepranay">
              <Box
                component="img"
                src="https://github-readme-streak-stats.herokuapp.com/?user=khadsepranay"
                width={{lg:"100%",md:"70%",sm:"85vw",xs:"85vw"}}
              />
            </Link>
          </Box>
          <Box>
            <Link href="https://github.com/khadsepranay">
              <Box
                component="img"
                src="https://github-readme-stats.vercel.app/api?username=khadsepranay&count_private=true&show_icons=true"
                width={{lg:"100%",md:"70%",sm:"85vw",xs:"85vw"}}
              />
            </Link>
          </Box>
        </Box>
        <Box>
          <Link href="https://github.com/khadsepranay">
            <Box
              component="img"
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=khadsepranay"
              width={{lg:"50%",md:"70%",sm:"70%",xs:"70%"}}
              height='250px'
            />
          </Link>
        </Box>
        <Box
          sx={{
            width: '90vw',
            margin: "auto",
            textAlign: "justify",
            fontSize: {lg:"55px",md:"55px",sm:"50px",xs:"45px"},
            color: "teal",
            boxSizing: "border-box",
            marginTop: "100px",
            padding: "0px",
          }}
        >
          GitHub Calendar
          <hr />
        </Box>
        <Box sx={{margin:'40px auto 0px',width:'85vw',paddingBottom:'100px'}}>
        <GitHubCalendar
        username="khadsepranay"
        blockSize={25}
        blockMargin={8}
        theme={colorTheme}
        fontSize={15}
      />
      </Box>
      </Box>
    </Box>
  );
}

export default Projects;
